<app-activity-display
  [activity]="activity()"
  [hostUrl]="hostUrl()"
  [isPreview]="false"
  #activityDisplay>
</app-activity-display>

<app-responsive-buttons #bottomButtons>
  <button type="button" class="btn btn-light text-uppercase" (click)="close()">
    Fermer
  </button>
  <button type="button" class="btn btn-light text-uppercase" (click)="share()">
    <lucide-icon [img]="icons.share"></lucide-icon>
  </button>
  @if (hasMessaging()) {
    <button type="button" class="btn btn-primary text-uppercase"
            (click)="activityDisplay.toggleShowContact()">Contacter
    </button>
  }
</app-responsive-buttons>
